module.exports = __webpack_public_path__ + "img/articles_favoris.99ef4518.svg";